import React, { useContext, useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { tabulatorGet, downloadBlobGet, fetchTextGet, deleteRequest } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { Avatar } from 'primereact/avatar';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, CalendarIcon, CalendarOffIcon, EditRowIcon } from "../svg/svgIcons";
import { DateTime } from "luxon";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { LocaleContext } from '../../components/LocaleContext';
import { getEffectiveMask } from '../../utils/effectiveMask';
import { cleanSorters, coerceHeaderFilterList, extractSafePaginationParams, createDedupedAjaxRequest, safeParse, parseSorters, parseMaskFilters, mergePagedStandardListFiltersAndSorters, sanitizeTabulatorLayoutAttributes, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS } from '../../utils/tabulatorProgressiveLoading';
import { dateUserHeaderFilter } from '../../utils/dateUserHeaderFilter';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle, tabulatorDateUserColumnMinWidth } from '../../utils/tabulatorColumnMinWidth';
import { buildTabulatorIdColumn } from '../../utils/tabulatorIdColumn';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT } from '../../utils/tabulatorAuditColumns';
import {
  ERROR_RECORDS_UPDATED_EVENT,
  SESSION_SAFE_UPDATE,
  applyPagedMutationOverlay,
  classifyErrorRecordListMutation,
  isAcknowledgedErrorRecordUpdateEcho,
} from '../../utils/errorRecordListSync';
import { pinErrorRecordLeadingColumns } from '../../utils/errorRecordListMasks';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../utils/serviceTaskExport';
import { xlsxDownloadFilename } from '../../utils/exportExcelNaming';
import PrintOptionsDialog from '../../components/PrintOptionsDialog';
import { getPusherChannel } from '../../utils/pusherChannel';
import { getCurrency } from '../../utils/moduleSettings';
import { formatCurrency } from '../../utils/currencyUtils';
import { otkReportActionLabelKey } from '../../utils/otkErrorRecordReportLabel';
import { serializePreviewDateForApi } from '../../utils/previewPeriodSelection';
import { useReactToPrint } from 'react-to-print';
import EightDreport from '../print/EightDreport';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
const ERROR_RECORD_PROGRESSIVE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'specific_id': 'Poradove cislo',
  'article_number': 'Artikel',
  'article_name': 'Nazov artikla',
  'order_number': 'Zakazka',
  'customer.name': 'Zakaznik',
  'offender_id': 'Vinnik',
  'repair_costs': 'Naklady',
  'total_amount': 'Mnozstvo',
  'defective_pieces': 'Pocet chybnych',
  'group.name': 'Skupina',
  'ack_error': 'Chyba',
  'claim_counterparty_number': 'Cislo reklamacie',
  'error_type.name': 'Druh chyby',
  'contractor_note': 'Pozn. zadávateľa',
  'record_processor.name': 'Spracovateľ',
  'problem_description': 'Popis problému',
  'main_reason': 'Hlavná príčina',
  'immediate_measure': 'Okamžité opatrenie',
  'long_term_measure': 'Dlhodobé opatrenie',
  'prevention.name': 'Zabránenie skrz',
  'root_cause.name': 'Korenova pricina',
  'auditor.name': 'Kontrolór',
  'auditor_note': 'Pozn. kontrolóra',
  'state': 'Stav',
  'created_at': 'EmployeeList.Column.CreatedAt',
  'updated_at': 'EmployeeList.Column.UpdatedAt',
});



const DEFAULT_COLUMNS_VISIBLE = Object.freeze({
  id: true,
  specific_id: true,
  article_number: true,
  article_name: true,
  order_number: true,
  'customer.name': true,
  offender_id: true,
  repair_costs: true,
  total_amount: true,
  defective_pieces: true,
  'group.name': true,
  ack_error: true,
  claim_counterparty_number: true,
  'error_type.name': true,
  contractor_note: true,
  'record_processor.name': true,
  problem_description: true,
  main_reason: true,
  immediate_measure: true,
  long_term_measure: true,
  'prevention.name': true,
  'root_cause.name': true,
  'auditor.name': true,
  auditor_note: true,
  state: true,
  created_at: true,
  updated_at: true,
});

function mergeVisibility(saved) {
  const merged = { ...DEFAULT_COLUMNS_VISIBLE };
  if (saved && typeof saved === 'object') {
    Object.keys(DEFAULT_COLUMNS_VISIBLE).forEach((k) => {
      if (Object.prototype.hasOwnProperty.call(saved, k)) merged[k] = saved[k] !== false;
    });
  }
  if (!Object.values(merged).some(Boolean)) return { ...DEFAULT_COLUMNS_VISIBLE };
  return merged;
}

function applyDataColumnVisibilityToTable(table, visibilityMap) {
  if (!table) return;
  for (const f of Object.keys(DEFAULT_COLUMNS_VISIBLE)) {
    if (visibilityMap[f] === false) table.hideColumn?.(f);
    else table.showColumn?.(f);
  }
  setTimeout(() => table.redraw?.(true), 0);
}

function layoutAttributesIncludeId(attributes) {
  if (!Array.isArray(attributes)) return false;
  return attributes.some((node) => node && typeof node === 'object' && node.field === 'id');
}

function localizedJsonName(value, locale) {
  if (value == null) return '';
  if (typeof value === 'object') return value[locale] || value.sk || '';
  return String(value);
}

function errorRecordHeaderFiltersEquivalent(a, b) {
  const norm = (list) => coerceHeaderFilterList(list)
    .filter((filter) => filter?.field && String(filter.value ?? '').trim() !== '')
    .map((filter) => `${filter.field}\0${String(filter.value).trim()}`)
    .sort()
    .join('\n');
  return norm(a) === norm(b);
}

export default function ErrorRecordProgressiveList({ mask, preview = null, timePeriod = null, date = null }) {
  const [state, dispatch] = useContext(DatabaseContext);
  const { user } = useContext(AuthContext);
  const { locale, t } = useContext(LocaleContext);
  const { setUserMaskFilter, openFavoriteDialog, toast, setFastView, getDateFormat, formatDate, getUserColor, getUserInitials, openChosenNotificationPreferences, setDialogText, setVisible } = useContext(UtilContext);
  const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
  const dateTimeFmt = `${dateFmt} HH:mm`;
  const currency = getCurrency(state.module_settings || []);

  const pageSizePc = useMemo(() => {
    const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
    const n = parseInt(v, 10);
    return (Number.isFinite(n) && n > 0) ? n : 50;
  }, [state.module_settings]);

  const [editIcon, setEditIcon] = useState(true);
  const [deleteIcon, setDeleteIcon] = useState(true);
  const [copyIcon, setCopyIcon] = useState(true);
  const insertIcon = !user.permissions?.includes('add otk-section1');
  const [visibleSearch, setVisibleSearch] = useState(false);
  const [searchIconColor, setSearchIconColor] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [markUnmark, setMarkUnmarked] = useState(true);
  const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE });
  const [maskVisible, setMaskVisible] = useState(false);
  const [printChoiceVisible, setPrintChoiceVisible] = useState(false);
  const [printOrientationChoice, setPrintOrientationChoice] = useState('landscape');
  const [printLayoutChoice, setPrintLayoutChoice] = useState('branded');
  const [printVisible, setPrintVisible] = useState(false);
  const [printValue, setPrintValue] = useState('Zoznam');
  const [visibleCalendar, setVisibleCalendar] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [calendarActive, setCalendarActive] = useState(false);
  const [editErrorRecord, setEditErrorRecord] = useState([]);
  const [tableSessionKey, setTableSessionKey] = useState(0);

  const ref = useRef(null);
  const componentRef = useRef(null);
  const overlayRef = useRef(null);
  const inFlightRef = useRef({ sig: null, promise: null });
  const completedCacheRef = useRef(new Map());
  const tableBuiltRef = useRef(false);
  const lastResponseRef = useRef(null);
  const isRestoringRef = useRef(false);
  const userInteractedRef = useRef(false);
  const savedHScrollRef = useRef({ left: 0, pending: false });
  const lastContainerHeightRef = useRef(0);
  const submittedSearchValueRef = useRef('');
  const submittedFromDateRef = useRef('');
  const submittedToDateRef = useRef('');
  const pendingInvalidationRef = useRef(false);
  const mutationOverlayRef = useRef(new Map());
  const listMountedRef = useRef(true);
  const restartQueuedRef = useRef(false);
  const ajaxGenerationRef = useRef(0);
  const confirmedQueryRef = useRef({ filters: [], sorters: [] });
  const sessionQueryActiveRef = useRef(false);
  const tableContainerRef = useRef(null);

  const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
  const isTableVisible = useCallback(() => {
    const el = tableContainerRef.current;
    if (el && el.offsetParent != null && el.clientHeight > 0) return true;
    const table = getTable();
    const tel = table?.getElement?.() ?? table?.element;
    return !!(tel && tel.offsetParent != null && tel.clientHeight > 0);
  }, [getTable]);

  const snapshotConfirmedQuery = useCallback(() => {
    const table = getTable();
    confirmedQueryRef.current = {
      filters: coerceHeaderFilterList(table?.getHeaderFilters?.()),
      sorters: cleanSorters(table?.getSorters?.() || []),
    };
  }, [getTable]);

  const restartFullProgressiveSession = useCallback(() => {
    if (!listMountedRef.current || restartQueuedRef.current) return;
    snapshotConfirmedQuery();
    sessionQueryActiveRef.current = true;
    ajaxGenerationRef.current += 1;
    pendingInvalidationRef.current = false;
    mutationOverlayRef.current = new Map();
    restartQueuedRef.current = true;
    completedCacheRef.current.clear();
    lastResponseRef.current = null;
    inFlightRef.current = { sig: null, promise: null };
    tableBuiltRef.current = false;
    isRestoringRef.current = true;
    const table = getTable();
    if (typeof table?.destroy === 'function') table.destroy();
    ref.current = null;
    setTableSessionKey((key) => key + 1);
  }, [getTable, snapshotConfirmedQuery]);

  const requestFullProgressiveSessionRestart = useCallback(() => {
    if (!listMountedRef.current) return;
    if (!isTableVisible()) {
      pendingInvalidationRef.current = true;
      return;
    }
    restartFullProgressiveSession();
  }, [isTableVisible, restartFullProgressiveSession]);

  const getLoadedRowComponent = useCallback((id) => {
    const table = getTable();
    if (!table || typeof table.getRow !== 'function' || id == null || id === '') return null;
    try {
      const row = table.getRow(id);
      return row && row !== false ? row : null;
    } catch (_e) {
      return null;
    }
  }, [getTable]);

  const applySafeErrorRecordPatch = useCallback((detail) => {
    const canonicalRow = detail?.row && typeof detail.row === 'object' && !Array.isArray(detail.row)
      ? (detail.row.data && detail.row.data.id != null ? detail.row.data : detail.row)
      : null;
    const id = detail?.id ?? canonicalRow?.id;
    const rowComponent = getLoadedRowComponent(id);
    if (!rowComponent || typeof rowComponent.update !== 'function' || !canonicalRow) {
      requestFullProgressiveSessionRestart();
      return;
    }
    rowComponent.update(canonicalRow);
    mutationOverlayRef.current.set(String(id), canonicalRow);
  }, [getLoadedRowComponent, requestFullProgressiveSessionRestart]);

  const captureHScroll = useCallback(() => {
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    if (!holder) return;
    savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
  }, [getTable]);

  const restoreHScroll = useCallback(() => {
    if (!savedHScrollRef.current.pending) return;
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    const header = table.columnManager?.contentsElement;
    if (!holder) return;
    const left = savedHScrollRef.current.left;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        holder.scrollLeft = left;
        if (header) header.scrollLeft = left;
        savedHScrollRef.current.pending = false;
      });
    });
  }, [getTable]);

  const handlePrint = useReactToPrint({
    onBeforeGetContent: () => { if (componentRef.current) componentRef.current.style.display = 'block'; },
    onAfterPrint: () => { if (componentRef.current) componentRef.current.style.display = 'none'; },
    content: () => componentRef.current,
  });

  useEffect(() => {
    listMountedRef.current = true;
    return () => { listMountedRef.current = false; };
  }, []);

  useEffect(() => {
    const el = tableContainerRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => {
      const h = el.clientHeight;
      const visible = h > 0 || isTableVisible();
      if (visible) {
        const wasHidden = lastContainerHeightRef.current <= 0;
        lastContainerHeightRef.current = Math.max(h, 1);
        if (pendingInvalidationRef.current) {
          requestAnimationFrame(() => restartFullProgressiveSession());
        } else if (wasHidden) {
          requestAnimationFrame(() => getTable()?.redraw?.(true));
        }
      } else {
        lastContainerHeightRef.current = 0;
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [getTable, isTableVisible, restartFullProgressiveSession]);

  useEffect(() => {
    const onUpdated = (event) => {
      const table = getTable();
      const decision = classifyErrorRecordListMutation(event, {
        toolbarSearch: submittedSearchValueRef.current,
        activeHeaderFilters: coerceHeaderFilterList(table?.getHeaderFilters?.()),
        activeSorters: cleanSorters(table?.getSorters?.() || []),
        isRowLoaded: (id) => Boolean(getLoadedRowComponent(id)),
      });
      if (decision === SESSION_SAFE_UPDATE) {
        applySafeErrorRecordPatch(event.detail);
        return;
      }
      requestFullProgressiveSessionRestart();
    };
    window.addEventListener(ERROR_RECORDS_UPDATED_EVENT, onUpdated);
    return () => window.removeEventListener(ERROR_RECORDS_UPDATED_EVENT, onUpdated);
  }, [applySafeErrorRecordPatch, getLoadedRowComponent, getTable, requestFullProgressiveSessionRestart]);

  useEffect(() => {
    const channel = getPusherChannel();
    if (!channel) return;
    const invalidate = () => requestFullProgressiveSessionRestart();
    const onUpdated = (payload) => {
      if (isAcknowledgedErrorRecordUpdateEcho(payload, mutationOverlayRef.current)) return;
      invalidate();
    };
    channel.bind('error_record.created', invalidate);
    channel.bind('error_record.updated', onUpdated);
    channel.bind('error_record.deleted', invalidate);
    return () => {
      channel.unbind('error_record.created', invalidate);
      channel.unbind('error_record.updated', onUpdated);
      channel.unbind('error_record.deleted', invalidate);
    };
  }, [requestFullProgressiveSessionRestart]);

  function EditRowFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon /></button></div>;
  }

  function OffenderFormatter(props) {
    const rowData = props.cell.getRow().getData();
    if (rowData.offender == null) return '';
    if (rowData.offender.type === 'customer') {
      return (state.companies || []).find((c) => c.customer_offender_id === rowData.offender_id)?.name || rowData.offender?.customer?.name || '';
    }
    if (rowData.offender.type === 'supplier') {
      return (state.companies || []).find((c) => c.supplier_offender_id === rowData.offender_id)?.name || rowData.offender?.supplier?.name || '';
    }
    return (state.employees || []).find((e) => e.offender_id === rowData.offender_id)?.name || rowData.offender?.employee?.name || '';
  }

  function auditDateText(raw) {
    if (raw == null || raw === '') return '';
    if (formatDate) {
      const text = formatDate(raw, dateTimeFmt, true);
      return text || '';
    }
    const dt = DateTime.fromISO(String(raw));
    return dt.isValid ? dt.toFormat(dateTimeFmt) : '';
  }

  function CreatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const u = rowData?.created_by_user;
    const contractor = !u ? rowData?.contractor : null;
    const contractorName = contractor?.name ? String(contractor.name).trim() : '';
    const displayName = u
      ? (u?.employee?.name || u?.username || '')
      : contractorName;
    const avatarTitle = u
      ? displayName
      : (contractorName
        ? t('ErrorRecordList.CreatedAt.LegacyContractorTooltip')
        : '');
    const colorKey = u?.username || contractorName || '';
    const text = auditDateText(rowData?.created_at);
    const showAvatar = Boolean(u || contractorName);
    return (
      <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
        {showAvatar ? (
          <Avatar
            className="shrink-0"
            title={avatarTitle}
            label={getUserInitials?.(displayName) || ''}
            shape="circle"
            style={{ backgroundColor: getUserColor?.(colorKey) || '#6b7280', color: '#ffffff' }}
          />
        ) : null}
        <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
      </div>
    );
  }

  function UpdatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const u = rowData?.updated_by_user;
    const displayName = u?.employee?.name || u?.username || '';
    const text = auditDateText(rowData?.updated_at);
    return (
      <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
        {u ? (
          <Avatar
            className="shrink-0"
            title={displayName}
            label={getUserInitials?.(displayName) || ''}
            shape="circle"
            style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
          />
        ) : null}
        <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
      </div>
    );
  }

  const textHeaderFilter = useCallback((headerValue) => {
    if (!headerValue || String(headerValue).trim() === '') return true;
    return true;
  }, []);

  const dateColumnFilter = useCallback((headerValue) => {
    if (!headerValue || String(headerValue).trim() === '') return true;
    return true;
  }, []);

  const idTitle = t('ErrorRecordList.Column.Id');
  const createdTitle = t('ErrorRecordList.Column.CreatedAt');
  const updatedTitle = t('ErrorRecordList.Column.UpdatedAt');

  const columns = useMemo(() => [
    { field: 'rowSelection', formatter: 'rowSelection', titleFormatter: 'rowSelection', hozAlign: 'center', width: 44, minWidth: 44, headerSort: false, resizable: false, frozen: true, print: false, download: false, headerFilter: false },
    { title: '', field: 'editor', hozAlign: 'center', width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter />), resizable: false, frozen: true, print: false, download: false, headerFilter: false },
    buildTabulatorIdColumn({ frozen: true, headerFilter: false, extra: { title: idTitle, print: false, download: false, headerFilter: false } }),
    { title: t('Poradove cislo'), field: 'specific_id', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Poradove cislo')), widthGrow: 1 },
    { title: t('Artikel'), field: 'article_number', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Artikel')), widthGrow: 1 },
    { title: t('Nazov artikla'), field: 'article_name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Nazov artikla')), widthGrow: 1 },
    { title: t('Zakazka'), field: 'order_number', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Zakazka')), widthGrow: 1 },
    { title: t('Zakaznik'), field: 'customer.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Zakaznik')), widthGrow: 1 },
    { title: t('Vinnik'), field: 'offender_id', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Vinnik')), widthGrow: 1, formatter: reactFormatter(<OffenderFormatter />) },
    { title: t('Naklady'), field: 'repair_costs', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Naklady')), widthGrow: 1, formatter: (cell) => formatCurrency(cell.getValue(), currency) },
    { title: t('Mnozstvo'), field: 'total_amount', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Mnozstvo')), widthGrow: 1 },
    { title: t('Pocet chybnych'), field: 'defective_pieces', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Pocet chybnych')), widthGrow: 1 },
    { title: t('Skupina'), field: 'group.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Skupina')), widthGrow: 1, formatter: (cell) => localizedJsonName(cell.getValue(), locale) },
    { title: t('Chyba'), field: 'ack_error', headerFilter: 'list', headerFilterLiveFilter: false, headerFilterParams: { values: { '': t('Všetko'), Uznaná: t('Uznaná'), Neuznaná: t('Neuznaná'), Prázdne: t('Prázdne') } }, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Chyba')), widthGrow: 1, formatter: (cell) => t(cell.getValue() || '') },
    { title: t('Cislo reklamacie'), field: 'claim_counterparty_number', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Cislo reklamacie')), widthGrow: 1 },
    { title: t('Druh chyby'), field: 'error_type.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Druh chyby')), widthGrow: 1, formatter: (cell) => localizedJsonName(cell.getValue(), locale) },
    { title: t('Pozn. zadávateľa'), field: 'contractor_note', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Pozn. zadávateľa')), widthGrow: 1 },
    { title: t('Spracovateľ'), field: 'record_processor.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Spracovateľ')), widthGrow: 1 },
    { title: t('Popis problému'), field: 'problem_description', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Popis problému')), widthGrow: 1 },
    { title: t('Hlavná príčina'), field: 'main_reason', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Hlavná príčina')), widthGrow: 1 },
    { title: t('Okamžité opatrenie'), field: 'immediate_measure', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Okamžité opatrenie')), widthGrow: 1 },
    { title: t('Dlhodobé opatrenie'), field: 'long_term_measure', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Dlhodobé opatrenie')), widthGrow: 1 },
    { title: t('Zabránenie skrz'), field: 'prevention.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Zabránenie skrz')), widthGrow: 1, formatter: (cell) => localizedJsonName(cell.getValue(), locale) },
    { title: t('Korenova pricina'), field: 'root_cause.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Korenova pricina')), widthGrow: 1, formatter: (cell) => localizedJsonName(cell.getValue(), locale) },
    { title: t('Kontrolór'), field: 'auditor.name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Kontrolór')), widthGrow: 1 },
    { title: t('Pozn. kontrolóra'), field: 'auditor_note', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Pozn. kontrolóra')), widthGrow: 1 },
    { title: t('Stav'), field: 'state', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Stav')), widthGrow: 1 },
    { title: createdTitle, field: 'created_at', minWidth: tabulatorDateUserColumnMinWidth(createdTitle), formatter: reactFormatter(<CreatedAtFormatter />), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: dateTimeFmt }, headerFilterFunc: dateColumnFilter, headerFilterFuncParams: { name: 'created_at' }, hozAlign: 'left', sorter: 'datetime', sorterParams: { format: 'iso' } },
    { title: updatedTitle, field: 'updated_at', minWidth: tabulatorDateUserColumnMinWidth(updatedTitle), formatter: reactFormatter(<UpdatedAtFormatter />), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: dateTimeFmt }, headerFilterFunc: dateColumnFilter, headerFilterFuncParams: { name: 'updated_at' }, hozAlign: 'left', sorter: 'datetime', sorterParams: { format: 'iso' } },
  ], [dateFmt, dateTimeFmt, createdTitle, updatedTitle, idTitle, t, locale, currency, textHeaderFilter, dateColumnFilter]);

  const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
    const extra = { ...extractSafePaginationParams(paramsFromTabulator), type: mask.errorRecordType };
    if (extra.size == null) extra.size = pageSizePc;
    if (preview != null && preview !== '') extra.preview = preview;
    if (timePeriod != null && timePeriod !== '') extra.timePeriod = timePeriod;
    // Local calendar date — must match PreviewOTK / mobile (never Date#toISOString UTC slice).
    const serializedDate = serializePreviewDateForApi(date);
    if (serializedDate != null) extra.date = serializedDate;
    if (submittedFromDateRef.current) extra.fromDate = submittedFromDateRef.current;
    if (submittedToDateRef.current) extra.toDate = submittedToDateRef.current;
    const previewDrilldown = preview != null && preview !== '';
    if (sessionQueryActiveRef.current) {
      coerceHeaderFilterList(confirmedQueryRef.current.filters).forEach((filter) => {
        if (!filter?.field) return;
        const value = filter.value;
        if (value == null || String(value).trim() === '') return;
        extra[`filter_${filter.field}`] = value;
      });
      const confirmedSorters = cleanSorters(confirmedQueryRef.current.sorters || []);
      if (confirmedSorters.length > 0) extra.sorters = JSON.stringify(confirmedSorters);
    } else if (!previewDrilldown) {
      // Preview drilldown must mirror card population (preview + period only).
      // Saved Zoznam* mask filters must not shrink the open/closed card set.
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable: tableBuiltRef.current ? getTable : () => null,
        tableBuiltForParams: tableBuiltRef.current,
        userMaskFilters: state.user_mask_filters,
        maskPage: mask.pageListKey,
        filterKeyStyle: 'literal_field',
      });
    } else if (!extra.sorters) {
      extra.sorters = JSON.stringify([{ column: 'specific_id', dir: 'desc' }]);
    }
    const search = String(submittedSearchValueRef.current ?? '').trim();
    if (search !== '') extra.toolbar_search = search;
    return extra;
  }, [getTable, state.user_mask_filters, pageSizePc, preview, timePeriod, date, mask]);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: ERROR_RECORD_PROGRESSIVE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


  const buildRequestParamsRef = useRef(buildRequestParams);
  buildRequestParamsRef.current = buildRequestParams;
  const getBuildRequestParams = useCallback((paramsFromTabulator) => buildRequestParamsRef.current(paramsFromTabulator), []);

  const getPrintColumnsOrder = useCallback(() => {
    const table = getTable();
    const allowed = Object.keys(DEFAULT_COLUMNS_VISIBLE).filter((f) => f !== 'id');
    const fallback = () => allowed.filter((f) => columnsVisible[f] !== false);
    if (!table?.getColumns) return fallback();
    const allowedSet = new Set(allowed);
    const out = [];
    const seen = new Set();
    try {
      table.getColumns().forEach((col) => {
        const field = col.getField?.() ?? col.getDefinition?.()?.field;
        if (!field || !allowedSet.has(field)) return;
        if (columnsVisible[field] === false) return;
        if (seen.has(field)) return;
        seen.add(field);
        out.push(field);
      });
    } catch (_) {
      return fallback();
    }
    return out.length > 0 ? out : fallback();
  }, [getTable, columnsVisible]);

  const buildErrorRecordExportQueryString = useCallback((opts = {}) => {
    const extra = { type: mask.errorRecordType };
    const previewDrilldown = preview != null && preview !== '';
    if (!previewDrilldown) {
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable: tableBuiltRef.current ? getTable : () => null,
        tableBuiltForParams: tableBuiltRef.current,
        userMaskFilters: state.user_mask_filters,
        maskPage: mask.pageListKey,
        filterKeyStyle: 'literal_field',
      });
    }
    const search = String(submittedSearchValueRef.current ?? '').trim();
    if (search !== '') extra.toolbar_search = search;
    if (submittedFromDateRef.current) extra.fromDate = submittedFromDateRef.current;
    if (submittedToDateRef.current) extra.toDate = submittedToDateRef.current;
    if (preview != null && preview !== '') extra.preview = preview;
    if (timePeriod != null && timePeriod !== '') extra.timePeriod = timePeriod;
    const serializedDate = serializePreviewDateForApi(date);
    if (serializedDate != null) extra.date = serializedDate;
    return buildExportQueryStringFromParams(extra, opts);
  }, [getTable, state.user_mask_filters, preview, timePeriod, date, mask]);

  const runErrorRecordPrint = useCallback(async () => {
    try {
      setPrintChoiceVisible(false);
      setPrintVisible(false);
      setDialogText?.(t('Common.PreparingPrint'));
      setVisible?.(true);
      const suffix = buildErrorRecordExportQueryString({
        includePrintColumns: true,
        printLayout: printLayoutChoice,
        printOrientation: printOrientationChoice,
        printColumns: getPrintColumnsOrder(),
      });
      const html = await fetchTextGet(`/api/error_records/export/print${suffix}`);
      if (!openPrintHtmlWindow(html)) {
        toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.PrintTitle'), detail: t('Common.EnablePopups'), life: 4000 });
      }
    } catch (e) {
      toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.PrintTitle'), detail: e?.message || t('DepartmentList.Toast.PrintFailed'), life: 4500 });
    } finally {
      setVisible?.(false);
    }
  }, [buildErrorRecordExportQueryString, getPrintColumnsOrder, printLayoutChoice, printOrientationChoice, setDialogText, setVisible, t, toast]);

  const exportErrorRecordsXlsx = useCallback(async () => {
    try {
      setDialogText?.(t('Common.PreparingExport'));
      setVisible?.(true);
      const suffix = buildErrorRecordExportQueryString({
        includePrintColumns: true,
        printColumns: getPrintColumnsOrder(),
      });
      const defaultXlsx = xlsxDownloadFilename(t(mask.exportTitleKey));
      const { blob, filename } = await downloadBlobGet(`/api/error_records/export/xlsx${suffix}`, defaultXlsx);
      triggerBlobDownload(blob, filename || defaultXlsx);
    } catch (e) {
      toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.ExportTitle'), detail: e?.message || t('DepartmentList.Toast.ExportFailed'), life: 4500 });
    } finally {
      setVisible?.(false);
    }
  }, [buildErrorRecordExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast, mask]);

  const restoreHeaderFilters = useCallback((table, rawFilters) => {
    const filterEntries = Array.isArray(rawFilters)
      ? rawFilters
      : (rawFilters && typeof rawFilters === 'object'
        ? Object.entries(rawFilters).map(([field, value]) => ({ field, value }))
        : []);
    filterEntries.forEach((filter) => {
      if (!filter?.field) return;
      const value = filter.value;
      if (value == null || value === '') return;
      const def = table.getColumn?.(filter.field)?.getDefinition?.();
      if (!def?.headerFilter) return;
      table.setHeaderFilterValue?.(filter.field, value, true);
    });
  }, []);

  const searchTable = () => {
    const normalized = String(searchValue ?? '').trim();
    submittedSearchValueRef.current = normalized;
    setSearchIconColor(normalized === '' ? '' : 'active');
    captureHScroll();
    requestFullProgressiveSessionRestart();
    setVisibleSearch(false);
  };

  const clearSearch = () => {
    setSearchIconColor('');
    setSearchValue('');
    submittedSearchValueRef.current = '';
    captureHScroll();
    requestFullProgressiveSessionRestart();
  };

  const searchByDate = () => {
    submittedFromDateRef.current = fromDate;
    submittedToDateRef.current = toDate;
    setCalendarActive(true);
    setVisibleCalendar(false);
    captureHScroll();
    requestFullProgressiveSessionRestart();
  };

  const clearCalendar = () => {
    setFromDate('');
    setToDate('');
    submittedFromDateRef.current = '';
    submittedToDateRef.current = '';
    setCalendarActive(false);
    captureHScroll();
    requestFullProgressiveSessionRestart();
  };

  const accept = () => {
    const rowsToDelete = getTable()?.getSelectedData?.() ?? [];
    if (rowsToDelete.length === 0) return;
    setDialogText?.(t('Common.LoadingData'));
    setVisible?.(true);
    const promises = rowsToDelete.map((element) => deleteRequest(`/api/error_records/${element.id}`));
    Promise.allSettled(promises).then((results) => {
      setVisible?.(false);
      const successCount = results.filter((r) => r.status === 'fulfilled').length;
      const failCount = results.filter((r) => r.status === 'rejected').length;
      if (successCount > 0 && failCount === 0) {
        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('ServiceTask.RecordDeleted') });
      } else if (failCount > 0) {
        toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.RecordDeleteFailed'), life: 3000 });
      }
      if (successCount > 0) {
        captureHScroll();
        requestFullProgressiveSessionRestart();
      }
    });
  };

  const reject = () => {
    toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.RequestCancelled'), life: 3000 });
  };

  const confirm = () => {
    confirmDialog({
      message: t('ServiceTask.ConfirmDeleteRecord'),
      header: t('Common.ConfirmDelete'),
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: t('Common.Yes'),
      rejectLabel: t('Common.No'),
      accept,
      reject,
    });
  };

  const onSelectRow = (data) => {
    setEditErrorRecord(data || []);
    if (!data || data.length === 0) {
      setEditIcon(true);
      setCopyIcon(true);
      setDeleteIcon(true);
      return;
    }
    if (data.length === 1) {
      if (user.permissions?.includes('add otk-section1') || data[0].contractor_id == user.employee?.id) setCopyIcon(false);
      if (user.permissions?.includes('edit otk-section2') || data[0].contractor_id == user.employee?.id) setEditIcon(false);
    } else {
      setEditIcon(true);
      setCopyIcon(true);
    }
    if (user.permissions?.includes('delete otk-section3')) setDeleteIcon(false);
  };

  function onEditRow(error_record) {
    dispatch({ type: 'create_new_tab', name: mask.editTabName, translationKey: mask.editTabKey, legacyLabel: mask.editTabName, page: mask.detailPage, props: { error_record, er_type: 'edit' }, mask: mask.detailMask });
  }

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());

  function addNewIntError() {
    dispatch({ type: 'create_new_tab', name: mask.addTabName, translationKey: mask.addTabKey, legacyLabel: mask.addTabName, page: mask.detailPage, props: { error_record: null, er_type: 'add' }, mask: mask.detailMask });
  }
  function copyIntError() {
    const sel = getTable()?.getSelectedData?.()?.[0];
    if (sel) dispatch({ type: 'create_new_tab', name: mask.addTabName, translationKey: mask.addTabKey, legacyLabel: mask.addTabName, page: mask.detailPage, props: { error_record: sel, er_type: 'add' }, mask: mask.detailMask });
  }
  function editIntError() {
    const sel = getTable()?.getSelectedData?.()?.[0];
    if (sel) dispatch({ type: 'create_new_tab', name: mask.editTabName, translationKey: mask.editTabKey, legacyLabel: mask.editTabName, page: mask.detailPage, props: { error_record: sel, er_type: 'edit' }, mask: mask.detailMask });
  }

  function setMask(item, value) {
    if (!Object.prototype.hasOwnProperty.call(DEFAULT_COLUMNS_VISIBLE, item)) return;
    const next = { ...DEFAULT_COLUMNS_VISIBLE, ...columnsVisible, [item]: value };
    if (!Object.values(next).some(Boolean)) return;
    applyDataColumnVisibilityToTable(getTable(), next);
    setColumnsVisible(next);
  }

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
      <span className={`${item.icon} text-primary`} />
      <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
      {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      setExpandedKeys({});
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => document.removeEventListener('click', handleClickOutside, true);
  }, []);

  const resetMask = () => resetTabulatorMask({
    page: mask.pageListKey,
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE,
    ref,
    columns,
    setColumnsVisible,
    onAfterReset: () => requestFullProgressiveSessionRestart(),
  });

  const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
        {
          key: '0_1',
          label: t('Common.SetFilter'),
          icon: 'pi pi-filter',
          command: () => { userInteractedRef.current = true; setUserMaskFilter(mask.pageListKey, 'set_filters', null, getTable()?.getHeaderFilters?.() ?? [], null); requestFullProgressiveSessionRestart(); },
          template: itemRenderer,
        },
        {
          key: '0_2',
          label: t('Common.ClearFilter'),
          icon: 'pi pi-filter-slash',
          command: () => { userInteractedRef.current = true; setUserMaskFilter(mask.pageListKey, 'set_filters', null, [], null); getTable()?.clearHeaderFilter?.(); requestFullProgressiveSessionRestart(); },
          template: itemRenderer,
        },
        {
          key: '0_3',
          label: t('Common.SetSorting'),
          icon: 'pi pi-sort-alt',
          command: () => { userInteractedRef.current = true; setUserMaskFilter(mask.pageListKey, 'set_sorters', null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); requestFullProgressiveSessionRestart(); },
          template: itemRenderer,
        },
        {
          key: '0_4',
          label: t('Common.ClearSorting'),
          icon: 'pi pi-sort-alt-slash',
          command: () => { userInteractedRef.current = true; setUserMaskFilter(mask.pageListKey, 'set_sorters', null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); requestFullProgressiveSessionRestart(); },
          template: itemRenderer,
        },
        {
          key: '0_5',
          label: t('Common.SetMask'),
          icon: 'pi pi-server',
          command: () => { setMaskVisible(true); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
          template: itemRenderer,
        },
        {
          key: '0_5b',
          label: t('Common.ResetUserMask'),
          icon: 'pi pi-refresh',
          command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
          template: itemRenderer,
        },
        {
          key: '0_6',
          label: t('Common.Notifications'),
          icon: 'pi pi-envelope',
          command: () => { openChosenNotificationPreferences(mask.notificationPage); OverflowMenuProvider.setVisible(null); },
          template: itemRenderer,
        },
      ],
    },
  ];

  function changeMarkings(value) {
    const next = { ...DEFAULT_COLUMNS_VISIBLE };
    Object.keys(next).forEach((k) => { next[k] = value; });
    if (!value) next.id = true;
    applyDataColumnVisibilityToTable(getTable(), next);
    setColumnsVisible(next);
  }

  function confirmPrintDialog() {
    if (printValue === 'Zoznam') {
      setPrintVisible(false);
      setPrintChoiceVisible(true);
    } else {
      setPrintVisible(false);
      handlePrint();
    }
  }

  return (
    <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <div className='w-full h-10 flex flex-row bg-[#333] shrink-0'>
        <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewIntError()}><AddIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editIntError()}><EditIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyIntError()}><CopyIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button type="button" onClick={() => setPrintVisible(true)}><PrintIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search">
            <button type="button" title={searchIconColor !== 'active' ? t('Common.Search') : t('ServiceTask.CancelSearch')} onClick={searchIconColor !== 'active' ? () => setVisibleSearch(true) : clearSearch}>
              {searchIconColor === '' ? <MdSearch fill='#fff' className='w-[28px] h-[28px]' aria-hidden="true" /> : <MdSearchOff fill='#fff' className='w-[28px] h-[28px]' aria-hidden="true" />}
            </button>
          </div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button type="button" onClick={() => exportErrorRecordsXlsx()} title={t('Common.ExportToExcel')}><ExportIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="calendar"><button type="button" onClick={!calendarActive ? () => setVisibleCalendar(true) : clearCalendar}>{calendarActive ? <CalendarOffIcon /> : <CalendarIcon />}</button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => requestFullProgressiveSessionRestart()} title={t('Common.Refresh')}><RefreshIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon /></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button type="button" onClick={() => scrollToFirst()}><BackToFirstIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button type="button" onClick={() => scrollUp()}><BackIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button type="button" onClick={() => scrollDown()}><ForwardIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button type="button" onClick={() => scrollToLast()}><ForwardToLastIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert2"><VerticalLineIcon /></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button type="button" onClick={() => openFavoriteDialog(t(mask.pageListKey), mask.pageListKey)}><FavoriteIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button type="button" onClick={() => setFastView(mask.pageListKey, columnsVisible, columns)}><PriceIcon /></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert3"><VerticalLineIcon /></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem" />
          </div>
        </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md flex-1 min-h-0 overflow-hidden'>
        <div ref={tableContainerRef} className="flex-1 min-h-0 overflow-hidden">
          <ReactTabulator
            key={tableSessionKey}
            className='h-[calc(100vh_-_193px)]'
            onRef={(r) => (ref.current = r?.current ?? r)}
            columns={columns}
            events={{
              rowSelectionChanged: onSelectRow,
              tableBuilt: () => {
                isRestoringRef.current = true;
                userInteractedRef.current = false;
                const table = getTable();
                const restartRestore = sessionQueryActiveRef.current;
                if (!table) {
                  tableBuiltRef.current = true;
                  restartQueuedRef.current = false;
                  snapshotConfirmedQuery();
                  setTimeout(() => {
                    isRestoringRef.current = false;
                    sessionQueryActiveRef.current = false;
                  }, 0);
                  return;
                }
                const effective = getEffectiveMask(mask.pageListKey, state);
                if (effective?.type === 'user' && effective.userMask) {
                  const userMask = effective.userMask;
                  try {
                    table.blockRedraw?.();
                    const attributes = pinErrorRecordLeadingColumns(
                      sanitizeTabulatorLayoutAttributes(safeParse(userMask.attributes, []), TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS)
                    );
                    if (layoutAttributesIncludeId(attributes) && attributes.length > 1) {
                      table.setColumnLayout?.(attributes);
                    }
                    if (restartRestore) {
                      restoreHeaderFilters(table, confirmedQueryRef.current.filters);
                    } else {
                      restoreHeaderFilters(table, parseMaskFilters(userMask.filters));
                      const sorters = parseSorters(userMask.sorters).map((s) => ({
                        column: s.column ?? s.field,
                        dir: s.dir === 'desc' ? 'desc' : 'asc',
                      }));
                      if (sorters.length > 0) table.setSort?.(sorters);
                    }
                    const jsonColumns = safeParse(userMask.columns, {});
                    if (jsonColumns && typeof jsonColumns === 'object' && !Array.isArray(jsonColumns)) {
                      const merged = mergeVisibility(jsonColumns);
                      setColumnsVisible(merged);
                      applyDataColumnVisibilityToTable(table, merged);
                    }
                  } finally {
                    table.restoreRedraw?.(true);
                  }
                } else if (effective?.type === 'standard' && effective.standardMask) {
                  try {
                    table.blockRedraw?.();
                    const attributes = pinErrorRecordLeadingColumns(
                      sanitizeTabulatorLayoutAttributes(safeParse(effective.standardMask.attributes, []), TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS)
                    );
                    const jsonColumns = safeParse(effective.standardMask.columns, {});
                    if (layoutAttributesIncludeId(attributes) && attributes.length > 1) {
                      try { table.setColumnLayout?.(attributes); } catch (_) {}
                    }
                    if (jsonColumns && typeof jsonColumns === 'object') {
                      const merged = mergeVisibility(jsonColumns);
                      setColumnsVisible(merged);
                      applyDataColumnVisibilityToTable(table, merged);
                    }
                    if (restartRestore) restoreHeaderFilters(table, confirmedQueryRef.current.filters);
                  } finally {
                    table.restoreRedraw?.(true);
                  }
                } else {
                  applyDataColumnVisibilityToTable(table, DEFAULT_COLUMNS_VISIBLE);
                  if (restartRestore) restoreHeaderFilters(table, confirmedQueryRef.current.filters);
                }
                tableBuiltRef.current = true;
                restartQueuedRef.current = false;
                snapshotConfirmedQuery();
                setTimeout(() => {
                  isRestoringRef.current = false;
                  sessionQueryActiveRef.current = false;
                }, 0);
              },
              headerFilterChanged: () => {
                if (isRestoringRef.current) return;
                const next = coerceHeaderFilterList(getTable()?.getHeaderFilters?.());
                if (errorRecordHeaderFiltersEquivalent(next, confirmedQueryRef.current.filters)) return;
                userInteractedRef.current = true;
                requestFullProgressiveSessionRestart();
              },
              sortChanged: () => {
                if (!isRestoringRef.current) userInteractedRef.current = true;
              },
              dataSorted: () => {
                if (!isRestoringRef.current) userInteractedRef.current = true;
              },
              columnMoved: () => {
                if (!userInteractedRef.current || isRestoringRef.current) return;
                setUserMaskFilter(mask.pageListKey, 'column_move', null, null, getTable()?.getColumnLayout?.());
              },
              columnResized: () => {
                if (!userInteractedRef.current || isRestoringRef.current) return;
                setUserMaskFilter(mask.pageListKey, 'column_resized', null, null, getTable()?.getColumnLayout?.());
              },
              renderComplete: () => restoreHScroll(),
            }}
            options={{
              index: 'id',
              renderHorizontal: 'virtual',
              layout: 'fitColumns',
              autoResize: true,
              rowHeight: TABULATOR_AUDIT_MIN_ROW_HEIGHT,
              movableColumns: true,
              headerSortTristate: true,
              ...(cleanSorters(confirmedQueryRef.current.sorters || []).length > 0
                ? {
                  initialSort: cleanSorters(confirmedQueryRef.current.sorters).map((sorter) => ({
                    column: sorter.field,
                    dir: sorter.dir,
                  })),
                }
                : { initialSort: [{ column: 'specific_id', dir: 'desc' }] }),
              ajaxURL: '/api/error_records/paged',
              ajaxParams: () => ({}),
              ajaxRequestFunc: (url, config, params) => {
                const generation = ajaxGenerationRef.current;
                return createDedupedAjaxRequest(getBuildRequestParams, tabulatorGet, inFlightRef, completedCacheRef, isRestoringRef, lastResponseRef)(url, config, params).then((data) => {
                  if (generation !== ajaxGenerationRef.current) {
                    return { data: [], last_page: data?.last_page ?? 1, total: 0, current_page: Number(params?.page) || 1 };
                  }
                  return data;
                });
              },
              dataLoader: true,
              dataLoaderLoading: t('Common.LoadingData'),
              dataLoaderError: t('Common.LoadFailed'),
              placeholder: t('Common.NoData'),
              height: 'calc(100vh - 193px)',
              progressiveLoad: 'scroll',
              progressiveLoadScrollMargin: 80,
              progressiveLoadDelay: 200,
              paginationSize: pageSizePc,
              filterMode: 'remote',
              sortMode: 'remote',
              pagination: false,
              ajaxRequesting: () => {
                if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
                const table = getTable();
                if (table?.initialized) table.alert?.(t('Common.LoadingData'));
                return true;
              },
              ajaxResponse: (url, params, response) => {
                getTable()?.clearAlert?.();
                const next = applyPagedMutationOverlay(response, mutationOverlayRef.current);
                if (next && typeof next === 'object') lastResponseRef.current = next;
                return next;
              },
              ajaxError: () => {
                getTable()?.clearAlert?.();
              },
              scrollToColumnIfVisible: false,
            }}
          />
        </div>
      </div>
      <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
        <div className="flex flex-columns">
          <input
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            type="text"
            className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
          />
          <button type="button" onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon /></button>
        </div>
      </Dialog>
      <Dialog header={t('MeasureGroupList.Search.ByDate')} visible={visibleCalendar} style={{ width: '40vw' }} onHide={() => setVisibleCalendar(false)}>
        <div className="flex flex-columns justify-between">
          <label>
            {t('MeasureGroupList.Search.From')}
            <input value={fromDate} onChange={(e) => setFromDate(e.target.value)} type="date" className="block w-full px-1 py-1 mr-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
          </label>
          <label>
            {t('MeasureGroupList.Search.To')}
            <input value={toDate} onChange={(e) => setToDate(e.target.value)} type="date" className="block w-full px-1 py-1 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40" />
          </label>
          <button type="button" onClick={() => searchByDate()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon /></button>
        </div>
      </Dialog>
      <Dialog header={t('Common.PrintAs')} visible={printVisible} style={{ width: '40vw' }} onHide={() => setPrintVisible(false)}>
        <div className="flex flex-columns">
          <select
            value={printValue}
            onChange={(e) => setPrintValue(e.target.value)}
            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option value="8D">{t(otkReportActionLabelKey(mask.errorRecordType))}</option>
            <option value="Zoznam">{t('Zoznam')}</option>
          </select>
          <button type="button" onClick={() => confirmPrintDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Common.Print')}</button>
        </div>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <button type="button" onClick={() => { changeMarkings(!markUnmark); setMarkUnmarked(!markUnmark); }} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAll') : t('Common.SelectAll')}</button>
          {columns.map(function (item, index) {
            if (!item?.field || !Object.prototype.hasOwnProperty.call(DEFAULT_COLUMNS_VISIBLE, item.field)) return null;
            return (
              <div key={item.field ?? index} className="flex flex-row border border-black rounded-md p-2 m-1">
                <Checkbox onChange={(e) => setMask(item.field, e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
              </div>
            );
          })}
          <button type="button" onClick={() => { setUserMaskFilter(mask.pageListKey, 'set_columns', columnsVisible, null, null); setMaskVisible(false); }} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Common.Save')}</button>
        </div>
      </Dialog>
      <PrintOptionsDialog
        visible={printChoiceVisible}
        onHide={() => setPrintChoiceVisible(false)}
        orientation={printOrientationChoice}
        onOrientationChange={setPrintOrientationChoice}
        layout={printLayoutChoice}
        onLayoutChange={setPrintLayoutChoice}
        onConfirm={runErrorRecordPrint}
      />
      <div ref={componentRef} style={{ display: 'none' }}>
        {editErrorRecord.map((error_record) => (
          <EightDreport key={error_record.id} error_record={error_record} />
        ))}
      </div>
    </div>
  );
}
